import Constants from 'expo-constants';
import * as Updates from 'expo-updates';
import { Platform } from 'react-native';
import { sentryEnvironmentFor } from './sentryEnvironment';

// Centralized build/release identifiers. Extracted from app/_layout.tsx so they
// can be shared between the early Sentry init (src/lib/sentryInit.ts, run from
// index.js) and the analytics super-properties / Sentry tags set later in
// app/_layout.tsx — without the two drifting apart.

export const SENTRY_DSN =
  process.env.EXPO_PUBLIC_SENTRY_DSN ||
  process.env.SENTRY_DSN ||
  'https://9c33c1a099fc5ccb0c60cca738ac7c7c@o4508245382856704.ingest.de.sentry.io/4509354909302864';

export const SENTRY_RELEASE =
  process.env.EXPO_PUBLIC_SENTRY_RELEASE ||
  process.env.SENTRY_RELEASE ||
  (Constants.expoConfig?.extra?.SENTRY_RELEASE as string | undefined) ||
  undefined;

export const APP_BUILD_VERSION = SENTRY_RELEASE || 'unknown';
export const APP_VERSION = Constants.expoConfig?.version || 'unknown';
export const APP_VARIANT = (Constants.expoConfig?.extra?.APP_VARIANT as string | undefined) || 'production';
export const SENTRY_ENVIRONMENT = sentryEnvironmentFor(
  APP_VARIANT,
  process.env.EXPO_PUBLIC_SENTRY_ENVIRONMENT
);
export const GIT_SHA = (Constants.expoConfig?.extra?.GIT_SHA as string | undefined) || 'unknown';
export const RUNTIME_VERSION = Updates.runtimeVersion || 'unknown';
export const OTA_UPDATE_ID = Updates.updateId || 'none';

// --- bounded client metadata for the association-validation audit boundary ----
// Mirrors the backend allowlist in companies.association_validation: the
// platform is one of ios|android|web (else 'unknown') and the release is
// <=20 chars of [0-9A-Za-z.-] (else 'unknown'). Derived from build info only —
// never user input/PII — and never used to authorize, reject or gate a request.
const CLIENT_PLATFORMS = ['ios', 'android', 'web'];
const CLIENT_RELEASE_CANDIDATE =
  APP_VERSION && APP_VERSION !== 'unknown' ? APP_VERSION : APP_BUILD_VERSION;

export const CLIENT_PLATFORM: string =
  CLIENT_PLATFORMS.includes(Platform.OS) ? Platform.OS : 'unknown';

export const CLIENT_RELEASE: string = (() => {
  const text = String(CLIENT_RELEASE_CANDIDATE || '').trim();
  return /^[0-9A-Za-z.\-]{1,20}$/.test(text) ? text : 'unknown';
})();
